import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Phone, MapPin, Mail, MessageCircle, Clock } from "lucide-react";

export default function Contact() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)); }, []);
  const b = s?.business || {};
  return (
    <div className="pt-24 pb-16 max-w-4xl mx-auto px-4" data-testid="contact-page">
      <span className="badge-gold">Visit us</span>
      <h1 className="font-serif text-4xl text-white mt-2">Contact Moon Hotel</h1>
      <div className="grid sm:grid-cols-2 gap-4 mt-8">
        {[
          { icon: <Phone />, label: "Phone", value: b.phone },
          { icon: <MessageCircle />, label: "WhatsApp", value: b.whatsapp },
          { icon: <Mail />, label: "Email", value: b.email },
          { icon: <MapPin />, label: "Address", value: b.address },
          { icon: <Clock />, label: "Hours", value: b.hours },
        ].map((c) => (
          <div key={c.label} className="card-lux p-4 flex gap-3 items-start">
            <div className="w-10 h-10 rounded-full bg-amber-500/10 text-amber-300 grid place-items-center">{c.icon}</div>
            <div>
              <div className="text-xs uppercase tracking-widest text-zinc-500 font-mono">{c.label}</div>
              <div className="text-white mt-1">{c.value || "TO BE PROVIDED"}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
